import React from "react";
import Select from "react-select";

const AdvancedSearchForm = ({
    show,
    filters,
    setFilters,
    onSearch,
    onClear,
    countries,
    t,
}) => {
    if (!show) return null;

    const handleSelectChange = (val) => {
        setFilters((prev) => ({
            ...prev,
            Country: val ? val.value : "",
        }));
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSelectFieldChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value === "" ? null : value === "true",
        }));
    };

    const handleIsDeletedChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            IsDeleted: e.target.value === "true",
        }));
    };

    const handleLimitChange = (e) => {
        setFilters((prev) => ({
            ...prev,
            Limit: parseInt(e.target.value) || 0,
        }));
    };

    return (
        <div className="adv-search-card mt-3">
            <div className="filter-card p-4">
                <h6 className="filter-section-title mb-3">
                    <i className="fal fa-sliders-h ml-2 text-success"></i>
                    {t("Pages.UsersControl.advancedSearch.title")}
                </h6>
                <div className="row">
                    {/* Country Selector */}
                    <div className="form-group col-md-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-globe ml-1 text-primary"></i>
                            {t("Pages.Register.Country.title")}
                        </label>
                        <Select
                            value={
                                filters.Country
                                    ? countries.find((c) => c.value === filters.Country)
                                    : null
                            }
                            name="Country"
                            placeholder={t("Pages.Register.Country.Placeholder")}
                            isClearable={true}
                            isRtl={true}
                            isSearchable={true}
                            onChange={handleSelectChange}
                            options={countries}
                            filterOption={(candidate, input) => {
                                if (input) {
                                    return candidate.data.name.includes(input);
                                }
                                return true;
                            }}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 8,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#92278f",
                                    primary: "#92278f",
                                },
                            })}
                        />
                    </div>

                    {/* CountryCustom selector */}
                    <div className="form-group col-md-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-map-marker-alt ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.Country.title")}
                        </label>
                        <select
                            value={
                                filters.CountryCustom === null
                                    ? ""
                                    : filters.CountryCustom
                                    ? "true"
                                    : "false"
                            }
                            onChange={(e) =>
                                handleSelectFieldChange("CountryCustom", e.target.value)
                            }
                            className="form-control adv-select-field"
                            name="CountryCustom"
                        >
                            <option value="">
                                {t("Pages.UsersControl.advancedSearch.Country.title")}
                            </option>
                            <option value="false">
                                {t("Pages.UsersControl.advancedSearch.Country.OutSide")}
                            </option>
                            <option value="true">
                                {t("Pages.UsersControl.advancedSearch.Country.InSide")}
                            </option>
                        </select>
                    </div>

                    {/* IsLocked selector */}
                    <div className="form-group col-md-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-lock ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.IsLocked.title")}
                        </label>
                        <select
                            value={
                                filters.IsLocked === null
                                    ? ""
                                    : filters.IsLocked
                                    ? "true"
                                    : "false"
                            }
                            onChange={(e) =>
                                handleSelectFieldChange("IsLocked", e.target.value)
                            }
                            className="form-control adv-select-field"
                            name="IsLocked"
                        >
                            <option value="">
                                {t("Pages.UsersControl.advancedSearch.IsLocked.title")}
                            </option>
                            <option value="false">{t("Pages.UsersControl.NotLocked")}</option>
                            <option value="true">{t("Pages.UsersControl.Locked")}</option>
                        </select>
                    </div>

                    {/* School Name */}
                    <div className="form-group col-md-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-school ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.name")}
                        </label>
                        <input
                            value={filters.Name}
                            onChange={handleFieldChange}
                            type="text"
                            name="Name"
                            className="form-control adv-search-input"
                            placeholder={t("Pages.UsersControl.advancedSearch.name")}
                        />
                    </div>

                    {/* Email */}
                    <div className="form-group col-md-3 mt-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-envelope ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.email")}
                        </label>
                        <input
                            value={filters.Email}
                            onChange={handleFieldChange}
                            type="text"
                            name="Email"
                            className="form-control adv-search-input"
                            placeholder={t("Pages.UsersControl.advancedSearch.email")}
                        />
                    </div>

                    {/* Phone */}
                    <div className="form-group col-md-3 mt-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-phone-alt ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.phone")}
                        </label>
                        <input
                            value={filters.Phone}
                            onChange={handleFieldChange}
                            type="text"
                            name="Phone"
                            className="form-control adv-search-input"
                            placeholder={t("Pages.UsersControl.advancedSearch.phone")}
                        />
                    </div>

                    {/* IsDeleted */}
                    <div className="form-group col-md-3 mt-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-trash-undo-alt ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.IsDeleted.title")}
                        </label>
                        <select
                            value={filters.IsDeleted ? "true" : "false"}
                            onChange={handleIsDeletedChange}
                            className="form-control adv-select-field"
                            name="IsDeleted"
                        >
                            <option value="false">{t("Pages.SchoolsControl.IsNotDeleted")}</option>
                            <option value="true">{t("Pages.SchoolsControl.IsDeleted")}</option>
                        </select>
                    </div>

                    {/* Code */}
                    <div className="form-group col-md-3 mt-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-barcode ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.Code")}
                        </label>
                        <input
                            value={filters.Code}
                            onChange={handleFieldChange}
                            type="text"
                            name="Code"
                            className="form-control adv-search-input"
                            placeholder={t("Pages.UsersControl.advancedSearch.Code")}
                        />
                    </div>

                    {/* Limit */}
                    <div className="form-group col-md-3 mt-3">
                        <label className="text-muted small font-weight-bold mb-1">
                            <i className="fad fa-list-ol ml-1 text-primary"></i>
                            {t("Pages.UsersControl.advancedSearch.limit")}
                        </label>
                        <input
                            value={filters.Limit}
                            onChange={handleLimitChange}
                            type="number"
                            step={1}
                            name="Limit"
                            className="form-control adv-search-input"
                        />
                    </div>

                    {/* Search & Clear buttons */}
                    <div className="form-group col-md-3 mt-3 d-flex align-items-end gap-2">
                        <button
                            type="button"
                            className="btn btn-primary flex-grow-1 d-flex align-items-center justify-content-center gap-2"
                            onClick={onSearch}
                            style={{ height: "42px", borderRadius: "8px", fontWeight: "600" }}
                        >
                            <i className="fas fa-sync-alt ml-2"></i>
                            {t("Pages.UsersControl.advancedSearch.send")}
                        </button>
                        <button
                            type="button"
                            className="btn btn-light border d-flex align-items-center justify-content-center px-3"
                            onClick={onClear}
                            title={t("Clear") || "مسح التصفية"}
                            style={{ height: "42px", borderRadius: "8px" }}
                        >
                            <i className="fal fa-trash-alt"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdvancedSearchForm;
